function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "url(#paint0_linear_11253_379121)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.0001 12.6499C15.2201 12.6499 11.3301 16.5399 11.3301 21.3199C11.3301 26.0999 15.2201 29.9999 20.0001 29.9999C24.7801 29.9999 28.6701 26.1099 28.6701 21.3299C28.6701 16.5499 24.7801 12.6499 20.0001 12.6499ZM20.7501 20.9999C20.7501 21.4099 20.4101 21.7499 20.0001 21.7499C19.5901 21.7499 19.2501 21.4099 19.2501 20.9999V15.9999C19.2501 15.5899 19.5901 15.2499 20.0001 15.2499C20.4101 15.2499 20.7501 15.5899 20.7501 15.9999V20.9999Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8901 11.45H17.1101C16.7101 11.45 16.3901 11.13 16.3901 10.73C16.3901 10.33 16.7101 10 17.1101 10H22.8901C23.2901 10 23.6101 10.32 23.6101 10.72C23.6101 11.12 23.2901 11.45 22.8901 11.45Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_11253_379121",
  x1: 0,
  y1: 20.2247,
  x2: 40,
  y2: 20.2247,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#265CAB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#2681E0"
})));

var SvgAlertLoginDark = function SvgAlertLoginDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAlertLoginDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AlertLogin_Dark.e2822d75.svg";
export { ForwardRef as ReactComponent };